import * as types from '../../src/actions/action-types';

export function managementUpdate(data) {
  return {
    type: types.MANAGEMENT_UPDATE,
    siteId: data.siteId,
    data: data.message,
  };
}
